import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";

import Footer from "../ones/Footer";
import banner1 from '../assets/banners/banner1.jpg';
import banner2 from '../assets/banners/banner2.jpg';
import banner3 from '../assets/banners/banner3.png';
import banner4 from '../assets/banners/banner4.jpg';
import banner5 from '../assets/banners/banner5.jpg';
import banner6 from '../assets/banners/banner6.jpg';
import xray from '../assets/banners/xray.jpg';


import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import { MdArrowCircleLeft, MdArrowCircleRight } from "react-icons/md";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner1, banner2, banner3];

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	// Background transition effect
	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if(ready) {
		return (
			<>
				<div className="MainBodySection">
					<div
						style={{
							width: "100%",
							height: "auto",
							position: "relative",
							overflow: "hidden"
						}}
					>
						{banners.map((banner, i) => (
							<div
								key={i}
								style={{
									backgroundImage: `url(${banner})`,
									backgroundAttachment: "fixed",
									backgroundSize: "cover",
									backgroundPosition: "center",
									width: "100%",
									height: "100%",
									position: "absolute",
									top: 0,
									left: 0,
									transition: "opacity 1.5s ease-in-out",
									opacity: i === bgIndex ? 1 : 0,
								}}
							/>
						))}
	
						{/* gradient overlay */}
						<div
							style={{
								width: "100%",
								height: "100%",
								background: "linear-gradient(to right, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 80%, rgba(0,0,0,0) 100%)",
								position: "relative",
								zIndex: 1
							}}
						>
							<div className="container">
								<div className="row">
									<div className="col-md-6">
										<h1
											className="font-bold text-light"
											style={{
												fontSize: "32px",
												paddingTop: "40px",
												paddingBottom: "40px",
												textTransform: "uppercase",
											}}
										>
											RADIOLOGY EQUIPEMENTS
										</h1>
	
										
	
									</div>
	
									
	
								</div>
							</div>
						</div>
	
					</div>
				</div>
				
				<div 
					className="MainBodySection"
					style={{
						paddingBottom: "50px",
						paddingTop: "50px"
					}}
				>
					<div className="container">
						<div className="row">

							

							<div className="col-md-12 mt-3 mb-3">
								<div 
									className="card"
									
								>
									<div className="card-body">

										<h6
											style={{
												fontSize: "32px"
											}}
											className="font-semi-bold mt-3 mb-3"
										>
											MRI Machine
										</h6>

										<img
											style={{
												width: "100%",
												height: "auto",
												
											}}
											src={banner4}
										/>

										<h6
											style={{
												fontSize: "18px"
											}}
											className="mt-3 mb-3"
										>
											Experience advanced diagnostic imaging with our high-performance MRI Machine, designed for exceptional image clarity and patient comfort. It delivers precise, non-invasive scans of soft tissues, organs, and the nervous system — ideal for hospitals and diagnostic centers seeking reliability and efficiency.
										</h6>

									</div>
								</div>
							</div>

							<div className="col-md-12 mt-3 mb-3">
								<div 
									className="card"
									
								>
									<div className="card-body">

										<h6
											style={{
												fontSize: "32px"
											}}
											className="font-semi-bold mt-3 mb-3"
										>
											X-RAY Machine
										</h6>

										<img
											style={{
												width: "100%",
												height: "auto",
												
											}}
											src={xray}
										/>

										<h6
											style={{
												fontSize: "18px"
											}}
											className="mt-3 mb-3"
										>
											Our X-Ray Machine provides fast and accurate imaging for bones, chest, and internal structures. Built with modern digital technology, it ensures clear results, low radiation exposure, and smooth operation, making it perfect for clinics and medical facilities of all sizes.
										</h6>

									</div>
								</div>
							</div>

							<div className="col-md-12 mt-3 mb-3">
								<div 
									className="card"
									
								>
									<div className="card-body">

										<h6
											style={{
												fontSize: "32px"
											}}
											className="font-semi-bold mt-3 mb-3"
										>
											CT Scan Machine
										</h6>

										<img
											style={{
												width: "100%",
												height: "auto",
												
											}}
											src={banner6}
										/>

										<h6
											style={{
												fontSize: "18px"
											}}
											className="mt-3 mb-3"
										>
											The CT Scan Machine offers high-resolution 3D imaging for quick and accurate diagnosis. Equipped with advanced detectors and intuitive software, it enables detailed visualization of internal organs and tissues while maintaining patient safety and comfort.
										</h6>

									</div>
								</div>
							</div>

							
	
						</div>
					</div>
				</div>

				<Footer/>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}
